import * as React from "react";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { FocusRequestsSourceContext } from "./FocusRequestsSources";

interface FocusManagementObserverProps {
    children: React.ReactNode;
    onRequestFocus: (path?: unknown) => void;
    onRequestPathAvailability?: (path: AbsoluteModelPath) => Promise<void>;
}

export function FocusManagementObserver(props: FocusManagementObserverProps): JSX.Element | null {
    const context = React.useContext(FocusRequestsSourceContext);
    React.useEffect(() => {
        context.addRequestFocusListener(props.onRequestFocus);
        if (props.onRequestPathAvailability != undefined) {
            context.addRequestPathAvailabilityListener(props.onRequestPathAvailability);
        }
        return () => {
            if (props.onRequestPathAvailability != undefined) {
                context.removeRequestPathAvailabilityListener(props.onRequestPathAvailability);
            }
            context.removeRequestFocusListener(props.onRequestFocus);
        };
    }, [props.onRequestFocus, props.onRequestPathAvailability]);
    return <>{props.children}</>;
}
